(function () {
    'use strict';

    angular
        .module('hrc.bimiboo.com')
        .directive('datePicker', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                templateUrl: 'templates/directives/date-range-picker.html',
                link: function ($scope, element) {

                    element.datepicker({
                        format: 'yyyy-mm-dd',
                        autoclose: true,
                        startView: 'decade'
                    }, function (start, end) {
                        $scope.dateFilter.callback();
                    });

                    $('.input-group-addon', element.parent()).on('click', function () {
                        element.focus();
                    })
                }
            };
        })
        .directive('yearPicker', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                templateUrl: 'templates/directives/date-range-picker.html',
                link: function ($scope, element) {

                    element.datepicker({
                        autoclose: true,
                        startView: 'decade',
                        format: "yyyy",
                        viewMode: "years",
                        minViewMode: "years"
                    }, function (start, end) {
                        $scope.dateFilter.callback();
                    });

                    $('.input-group-addon', element.parent()).on('click', function () {
                        element.focus();
                    })
                }
            };
        })
        .directive('monthPicker', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                templateUrl: 'templates/directives/date-range-picker.html',
                link: function ($scope, element) {

                    element.datepicker({
                        autoclose: true,
                        startView: 'decade',
                        format: "yyyy-mm",
                        viewMode: "months",
                        minViewMode: "months"
                    }, function (start, end) {
                        $scope.dateFilter.callback();
                    });

                    $('.input-group-addon', element.parent()).on('click', function () {
                        element.focus();
                    })
                }
            };
        });

})();